import $ from 'jquery';
import Counter from './generic/counter';
import SessionStoragePop from './generic/SessionStoragePop';
import MethodUtils from './generic/methodUtils';

const ACTIVATION_ENT_DEFAULT_VALUES = {
    URL_SERVICE : "/gax-web/gax/gax-pending-activation-requests-count.html",
    URL_SIGNATURE : "/com/icd-web/alerting/fil-alertes.html",
    SESSION_KEY: "ent_activation_counter",
    MOBILE_BREAKPOINT : 768
}

const ACTIVATION_ENT_SELECTOR = {
    ID_COUNTER: '#js-link-ent-activation',
    DATA_CHANNEL_ACTIVATION_ENT: "li[data-channelid='c4dc0026fc78d610VgnVCM100000da4658c0RCRD'] a",
}

export default class ActivationEnt {

    constructor() {
        var _self = this;

        _self.counterEmpty = true;

        // init default values
        _self.urlService = ACTIVATION_ENT_DEFAULT_VALUES.URL_SERVICE;
        _self.sessionKey = ACTIVATION_ENT_DEFAULT_VALUES.SESSION_KEY;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new SessionStoragePop(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new MethodUtils();

        // Custom channel ID
        _self.counterSelector = ACTIVATION_ENT_SELECTOR.DATA_CHANNEL_ACTIVATION_ENT;

        _self.isInRefreshingMode = true;

        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode)
                _self.updateNotification()
        }, _self.intervalTime);

        _self.waitUntil(
            function () {
                return $(_self.counterSelector).length > 0;
            },
            function () {
                // Init & counter
                _self.counter = new Counter(_self.counterSelector);
                _self.updateNotification()
            }, 50, 20
        );
    }

    initPropertiesFromConf() {
        this.intervalTime = window.cmsGlobals.activationEntConfig.intervalTime;
        if (window.cmsGlobals.activationEntConfig.urlActivationEntSignature) {
            this.urlActivationEntSignature = window.cmsGlobals.activationEntConfig.urlActivationEntSignature;
        } else {
            this.urlActivationEntSignature = ACTIVATION_ENT_DEFAULT_VALUES.URL_SIGNATURE;
        }
    }


    launchTimer(data, appliFunction, time) {
        if (data !== null) {
            setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
        }
        return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
    }

    /**
     * Get the value from the session storage, if no value, call Alerting service
     */
    updateNotification() {
        var _self = this;
        if (_self.urlActivationEntSignature.indexOf(window.location.pathname) !== -1) {
            _self.sessionStoragePop.resetCounterInSession();
            _self.updateDOM();
        } else {
            _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

            if (!_self.dataResponse) {
                _self.callActivationEntService();
            } else {
                // if interval expired, call service, else take the counter value in session
                if ( (new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                    _self.updateDOM();
                } else {
                    _self.callActivationEntService();
                }
            }
        }
    }

    /**
     * Call the service exposed by Alerting in order to recover the notification numbers
     */
    callActivationEntService() {
        var _self = this;

        $.ajax( {
            url:_self.urlService,
            method: "GET",
            swmIntercept: false,
            contentType : "application/xml; charset=utf-8",
            dataType: 'xml',
            beforeSend: function(request) {
                request.setRequestHeader("x-no-session-postpone", "true");
            },
            success: function (response) {
                if (response == undefined
                    || response.firstChild == null
                    || response.firstChild == undefined
                    || response.getElementsByTagName("nbDemActivAttente") == null
                    || response.getElementsByTagName("nbDemActivAttente")[0].firstChild == null) {

                    clearInterval(_self.intervalTime);
                    _self.sessionStoragePop.removeKey();

                    console.error("Pas de messages");
                } else {
                    var counter = response.getElementsByTagName("nbDemActivAttente")[0].firstChild.nodeValue;

                    // check if counter is well a number
                    if (isNaN(counter)) {
                        _self.sessionStoragePop.removeKey();
                        console.error("Counter not on right format");
                    } else {
                        _self.sessionStoragePop.updateCounterAlone(counter, false);
                        _self.updateDOM();
                    }
                }
            },
            error:  function () {
                _self.isInRefreshingMode = false;
                _self.sessionStoragePop.removeKey();
                console.error("Erreur réseau");
            }
        });
    }

    waitUntil(isready, success, count, interval){
        var _self = this;
        if (count === undefined) {
            count = 20;
        }
        if (interval === undefined) {
            interval = 20;
        }
        if (isready()) {
            success();
            return;
        }
        // The call back isn't ready. We need to wait for it
        setTimeout(function(){
            if (count) {
                // Try again
                _self.waitUntil(isready, count -1, interval);
            }
        }, interval);
    }

    /**
     * Update the html for both counter and infobulle
     */
    updateDOM() {
        var _self = this;
        var data = _self.sessionStoragePop.getJsonObjectFromSession();

        // Update Counter
        _self.counter.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
    }

}



// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/activation_ent.js